import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RoleCreationFailedAction = {
	type: 'ROLE_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RoleCreationFailedAction => ({
	type: 'ROLE_CREATION_FAILED',
	payload,
});
